import { onMounted, onBeforeUnmount, watch } from 'vue';
import { useRoute } from 'vue-router';
import {
  captureSignupAttribution,
  flushSignupJourneyEvents,
  isMessageProMarketingHost,
  readMarketingConsent,
  trackSignupJourneyEvent,
} from '../helpers/SignupAttribution';
import { syncMarketingConsent } from '../helpers/MarketingConsentSync';

export const useMarketingConsent = ({ authenticated = false } = {}) => {
  const route = useRoute();

  const synchronizeConsent = async () => {
    if (!isMessageProMarketingHost() || !authenticated) return;

    try {
      await syncMarketingConsent();
    } catch {
      // Retry the website's saved choice when the window receives focus again.
    }
  };

  const trackCurrentPage = () => {
    if (!isMessageProMarketingHost() || authenticated) return;

    captureSignupAttribution();
    if (readMarketingConsent()?.analytics !== true) return;

    flushSignupJourneyEvents();
    trackSignupJourneyEvent('page_view', {
      page_type: route.name?.toString() || 'auth',
      consent_source: 'auth_app',
    });
  };

  onMounted(() => {
    synchronizeConsent();
    trackCurrentPage();
    window.addEventListener('focus', synchronizeConsent);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('focus', synchronizeConsent);
  });

  watch(() => route.fullPath, trackCurrentPage);
};
